module.exports = __webpack_public_path__ + "wave-2.1M5ksmiB.svg";